<template>
  <div class="d-flex flex-column" style="margin: 0.3rem 0">
    <small> ضبط صدا </small>
    <BButton
      variant="transparent"
      v-if="mediaRecorderState == 'recording'"
      @click.stop="stopRecording"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="blob recorder-icons"
        viewBox="0 0 20 20"
        fill="currentColor"
        style="color: rgb(220 38 38)"
      >
        <path
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z"
          clip-rule="evenodd"
        />
      </svg>
    </BButton>
    <BButton variant="transparent" v-else @click="startRecording">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="recorder-icons"
        viewBox="0 0 20 20"
        fill="currentColor"
        style="color: rgb(59 130 246)"
      >
        <path
          fill-rule="evenodd"
          d="M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8a1 1 0 10-2 0A5 5 0 015 8a1 1 0 00-2 0 7.001 7.001 0 006 6.93V17H6a1 1 0 100 2h8a1 1 0 100-2h-3v-2.07z"
          clip-rule="evenodd"
        />
      </svg>
    </BButton>
    <template v-if="audioSrc">
      <div class="w-100 d-flex align-items-center justify-content-center">
        <audio preload="metadata" controls :src="audioSrc"></audio>
        <FeatherIcon
          @click="removeAudio"
          icon="Trash2Icon"
          class="text-danger ml-1 cursor-pointer"
          size="25"
        ></FeatherIcon>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    removeAudio() {
      URL.revokeObjectURL(this.audioSrc);
      this.audioBlob = null;
      this.audioSrc = null;
    },
  },
  mixins: [audioRecorderMixin],
  components: {
    BFormGroup,
    BButton,
  },
};
import audioRecorderMixin from "@/mixins/audioRecorderMixin";
import { BFormGroup, BButton } from "bootstrap-vue";
</script>
<style scoped>
.recorder-icons {
  width: 2rem;
  height: 2rem;
  cursor: pointer;
}
.blob {
  border-radius: 50%;
  box-shadow: 0 0 0 0 #ff0000;
  transform: scale(1);
  animation: pulse 1.2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 #ff0000b3;
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px #ff0000b3;
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 #ff0000b3;
  }
}
</style>
